import React from "react";
import "./CookiesModal.scss";

export default function CookiesModal({ setIsOpen }: { setIsOpen: (val: boolean) => void }) {
    const handleAction = () => {
        window.localStorage.setItem("cookies", "true");
        setIsOpen(true);
    };

    return (
        <div className="cookies-overlay">
            <div className="cookies-modal">
                <div className="cookies-content">
                    <p className="cookies-text">
                        Al hacer clic en «Aceptar todas las cookies», usted acepta el almacenamiento de cookies en su
                        dispositivo para mejorar la navegación del sitio, analizar el uso del mismo y ayudarnos en
                        nuestras iniciativas de marketing.
                    </p>

                    <div className="cookies-actions">
                        <button
                            className="btn btn_orange_transparent"
                            onClick={() => {
                                /* Lógica configurar */
                            }}
                        >
                            <span
                                style={{
                                    marginRight: "8px",
                                    color: "black",
                                    fontWeight: 700,
                                    fontSize: 14,
                                }}
                            >
                                Configurar cookies
                            </span>
                        </button>
                        <button className="btn btn_gray_light" onClick={handleAction}>
                            Rechazar cookies
                        </button>
                        <button className="btn btn_orange" onClick={handleAction}>
                            Aceptar cookies
                        </button>
                    </div>
                </div>

                {/* Decoración de líneas naranjas que se ve en la esquina inferior derecha */}
                <div className="cookies-decoration"></div>
            </div>
        </div>
    );
}
